import { render, staticRenderFns } from "./EzFormBlock.vue?vue&type=template&id=6976095a&scoped=true&"
import script from "./EzFormBlock.vue?vue&type=script&lang=js&"
export * from "./EzFormBlock.vue?vue&type=script&lang=js&"
import style0 from "./EzFormBlock.vue?vue&type=style&index=0&id=6976095a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976095a",
  null
  
)

export default component.exports